import { getBookings } from "@/pages/api/api"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

const initialState = {
  bookings: [],
  status: "idle", // For tracking loading status
  error: null,
}

export const fetchBookings = createAsyncThunk("bookings/fetchBookings", async (params, { rejectWithValue }) => {
  try {
    const response = await getBookings(params)
    return response
  } catch (err) {
    return rejectWithValue(err.response?.data?.msg || "Something went wrong")
  }
})

const bookingsSlice = createSlice({
  name: "bookings",
  initialState,
  reducers: {
    setBookingsState: (state, action) => {
      state.bookings = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookings.pending, (state) => {
        state.status = "loading"
      })
      .addCase(fetchBookings.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.bookings = action.payload
      })
      .addCase(fetchBookings.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { setBookingsState } = bookingsSlice.actions
export default bookingsSlice.reducer
